import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import NavRow from '../fields/NavRow';
import TextField from '../fields/TextField';
import { TaskDefinition, TaskStepRenderArgs } from '../QuestionnaireShell';
import { TaxIdValues } from '../types';
import { zodResolver } from '../validation';

const schema = z.object({
  taxId: z.string({ required_error: 'Tax ID is required but is missing' }).min(1, 'Tax ID is required but is missing'),
});

const DEFAULTS: TaxIdValues = { taxId: '' };

const TaxIdForm = ({ initialValues, onComplete, onBack, onCancelEdit, submitLabel }: TaskStepRenderArgs) => {
  const defaults = (initialValues as TaxIdValues | undefined) ?? DEFAULTS;
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<TaxIdValues>({
    defaultValues: defaults,
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit((values) => onComplete(values));

  return (
    <form className="rnq-form" onSubmit={(e) => e.preventDefault()}>
      <TextField control={control} name="taxId" label="Tax ID" required />
      <NavRow
        onBack={onBack}
        onCancelEdit={onCancelEdit}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        disabled={!isValid}
      />
    </form>
  );
};

const TaxId: TaskDefinition = {
  key: 'task15',
  label: 'Tax ID',
  title: 'Please provide your Tax ID',
  render: (args) => <TaxIdForm {...args} />,
};

export default TaxId;
